import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CalendarCheck, Compass, ShieldCheck, Star } from "lucide-react";
import { track } from "@/lib/analytics";

export const Hero = () => (
  <section className="relative overflow-hidden" data-testid="hero">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 lg:pt-16 pb-8 grid lg:grid-cols-2 gap-10 items-center">
      <div className="sc-fade-up">
        <span className="inline-block uppercase text-xs sm:text-sm font-bold tracking-widest text-emerald-800 bg-emerald-100 px-3 py-1.5 rounded-full">
          Dispositivo medico per la mobilità
        </span>
        <h1 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>
          SENIORCAR.<br /><span style={{ color: "var(--sc-emerald)" }}>La libertà di continuare a muoversi.</span>
        </h1>
        <p className="mt-5 text-lg sm:text-xl text-slate-600 leading-relaxed max-w-xl">
          Un dispositivo medico con abitacolo chiuso, progettato per le persone con patologie permanenti e difficoltà motorie. Monoposto, senza patente né targa, per ritrovare autonomia ogni giorno.
        </p>
        <div className="mt-6 inline-flex flex-wrap items-baseline gap-x-3 gap-y-1 rounded-2xl px-5 py-3 shadow-lg" style={{ backgroundColor: "var(--sc-emerald)" }} data-testid="hero-price-badge">
          <span className="text-sm font-semibold uppercase tracking-wide text-white/80">Da</span>
          <span className="text-3xl sm:text-4xl font-extrabold text-white" style={{ fontFamily: "Outfit" }}>€5.490</span>
          <span className="text-sm font-semibold text-white/90">+ IVA + trasporto</span>
          <span className="w-full text-xs font-medium text-white/80">con conferma dell'ordine online</span>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link to="/offerta">
            <Button className="h-14 px-7 text-lg font-bold text-white rounded-full gap-2 w-full sm:w-auto" style={{ backgroundColor: "var(--sc-amber)" }}
              data-testid="hero-prenota-button" onClick={() => track("cta_click", { cta: "ordina_online", source: "hero" })}>
              <CalendarCheck size={20} /> Prenota Online
            </Button>
          </Link>
          <Link to="/seniorcar">
            <Button variant="outline" className="h-14 px-7 text-lg font-bold rounded-full gap-2 w-full sm:w-auto border-2 border-emerald-800 text-emerald-900 hover:bg-emerald-50"
              data-testid="hero-scopri-button">
              <Compass size={20} /> Scopri SENIORCAR
            </Button>
          </Link>
        </div>
        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-600">
          <span className="flex items-center gap-1.5"><ShieldCheck size={18} className="text-emerald-700" /> Progettata secondo il quadro MDR europeo</span>
          <span className="flex items-center gap-1.5"><Star size={18} className="text-amber-500" /> Rete di centri in tutta Italia</span>
        </div>
      </div>
      <div className="sc-fade-up relative">
        <img src="https://customer-assets-rejwkqb3.emergentagent.net/job_seniorcar-discover/artifacts/4c34b0723c9344f2_A1C996A0-54BA-42D1-A436-A14BF8CA922D.png"
          alt="SENIORCAR: dispositivo medico monoposto con abitacolo chiuso per persone con difficoltà motorie"
          loading="eager" width="1200" height="900"
          className="rounded-3xl w-full h-[340px] sm:h-[440px] object-cover bg-white shadow-xl" />
        <div className="absolute -bottom-5 left-5 right-5 sm:left-8 sm:right-auto bg-white rounded-2xl shadow-lg p-4 flex items-center gap-3 border border-slate-100">
          <div className="w-11 h-11 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: "var(--sc-emerald)" }}><ShieldCheck size={22} /></div>
          <div><p className="font-bold text-slate-900 text-sm">Protetta dal meteo</p><p className="text-slate-500 text-xs">Esci anche con pioggia e freddo</p></div>
        </div>
      </div>
    </div>
  </section>
);
